import { CollectionFilter } from "@/modules/DashboardTemplate/models/CollectionFilter";
import { OptionsChart } from "@/modules/DashboardTemplate/models/optionsChart";
import { PropertiesChart } from "@/modules/DashboardTemplate/models/PropertiesChart";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { Utils } from "@/shared/utils/utils";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { LEGEND_CHART, TITLE_CHART } from "../ChartsConstants";
import {
  detectChartPieClick,
  getUserByDocument
} from "@/modules/DashboardTemplate/Utils";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { UserService } from "@/modules/User/services/UserService";

@Component({
  name: "DoughnutChart",
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      refreshCharts: "getRefreshCharts"
    })
  }
})
export default class DoughnutChart extends Vue {
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  refreshCharts!: number;
  @Inject() userService!: UserService;

  @Prop() propertiesToChart!: PropertiesChart;
  @Prop() dataToGraph?: CollectionFilter;

  showMenu = false;
  menuX = 0;
  menuY = 0;
  selectedBarData: any = null;
  chartOptions: OptionsChart = new OptionsChart();

  mounted() {
    this.chart();
    this.$nextTick(() => {
      const chartRef = this.$refs.myChart as any;
      if (chartRef && chartRef.$el) {
        chartRef.$el.addEventListener("contextmenu", (e: MouseEvent) => {
          e.preventDefault();
          this.handleRightClick(e);
        });
      }
    });
  }

  @Watch("refreshCharts")
  @Watch("propertiesToChart", { deep: true })
  onChangeData() {
    this.chart();
  }

  chart() {
    if (!this.dataToGraph) return;
    const dataToGraph = this.dataToGraph;
    const chartData = dataToGraph.chartData;

    const seriesData = [];
    for (let i = 0; i < chartData.xAxis.length; i++) {
      seriesData.push({
        name: chartData.xAxis[i],
        value: chartData.data[0].data[i]
      });
    }
    const color = Utils.generateColorsTones(
      this.propertiesToChart.chartColor.hex,
      6
    );
    this.chartOptions = {
      color,
      title: {
        ...TITLE_CHART,
        text: dataToGraph.chartName
      },
      tooltip: {
        trigger: "item"
      },
      legend: {
        ...LEGEND_CHART
      },
      series: [
        {
          name: dataToGraph.chartName,
          type: "pie",
          radius: ["40%", "70%"],
          center: ["35%", "50%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2
          },
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 16,
              fontWeight: "bold"
            }
          },
          data: seriesData
        }
      ]
    };
  }

  handleClick(event: any) {
    this.$emit("click", {
      chartType: "doughnut",
      event
    });
  }

  handleRightClick(e: MouseEvent) {
    // Validación: solo funciona para groupBy = "document" o "owner"
    const allowedGroupBy = ["document", "owner", "user", "userId"];
    const groupById = (this.propertiesToChart.groupBy[0] as DynamicSelectData)
      ?.id;

    if (!groupById || !allowedGroupBy.includes(groupById)) {
      return;
    }

    if (!this.dataToGraph) {
      return;
    }

    // Construir los datos de la serie en el formato [{name, value}]
    const chartData = this.dataToGraph.chartData;
    const seriesData = [];
    for (let i = 0; i < chartData.xAxis.length; i++) {
      seriesData.push({
        name: chartData.xAxis[i],
        value: chartData.data[0].data[i]
      });
    }

    // Usar la función de utilidad para detectar el click en gráfico tipo pie
    const chartRef = this.$refs.myChart as any;
    const pieData = detectChartPieClick(
      e,
      chartRef,
      seriesData,
      this.dataToGraph.collection[0].name
    );

    // Si se detectó un click válido en un segmento
    if (pieData) {
      this.selectedBarData = pieData;

      // Ocultar el tooltip
      if (chartRef && chartRef.chart) {
        chartRef.chart.dispatchAction({ type: "hideTip" });
      }

      // Mostrar el menú contextual
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.showMenu = true;
    }
  }

  async onMenuAction() {
    // Buscar usuario usando la función de utils
    const userId = await getUserByDocument(
      this.selectedBarData.label,
      this.userService
    );

    // Si se encontró el usuario, abrir su perfil en nueva pestaña
    if (userId) {
      const route = this.$router.resolve({ path: `/profile/${userId}` });
      window.open(route.href, "_blank");
      this.showMenu = false;
      return;
    }

    const route = this.$router.resolve({
      path: `/profile/${this.selectedBarData.label}`
    });
    window.open(route.href, "_blank");
    this.showMenu = false;
    // Cerrar el menú contextual
  }
}
